export default "__VITE_PUBLIC_ASSET__1f02f3f9__"